import { createFileRoute } from '@tanstack/react-router'
import SignupView from "../../signup/SignupView.tsx";

export const Route = createFileRoute('/signup/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <SignupView />
}
